
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2151',
  depVersions: {
  "customer-portal-app": "static-1.2151",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.461",
  "data-fetching-client": "static-1.9631",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.428",
  "growth-payments-core": "static-1.25224",
  "head-dlb": "static-1.4938",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5550",
  "hs-test-utils": "static-1.7973",
  "hub-http": "static-1.6178",
  "hub-http-shared-msw-handlers": "static-1.9854",
  "hubspot-dlb": "static-2.1832",
  "hubspot-prosemirror": "static-1.18097",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11418",
  "I18n": "static-7.1612",
  "immutable": "static-2.77",
  "jasmine-runner": "static-1.6426",
  "payment-link-components": "static-1.23396",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6963",
  "quartz-core": "static-1.6182",
  "react": "static-7.185",
  "react-colorpicker": "static-2.10167",
  "react-dlb": "static-1.78",
  "react-utils": "static-2.5308",
  "rich-text-lib": "static-1.19749",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17922",
  "ui-components-test-utils": "static-1.5556",
  "UIComponents": "static-3.8365",
  "foundations-assets": "static-1.4813",
  "foundations-components": "static-1.7844",
  "foundations-theming": "static-1.4373",
  "foundations-theming-specialty": "static-1.2089",
  "framer-motion": "static-1.71",
  "metrics-js": "static-1.9542",
  "PortalIdParser": "static-2.388",
  "portals-platform-lib": "static-1.809",
  "quartz-config": "static-1.741",
  "quartz-routing": "static-1.393",
  "quick-fetch": "static-1.3881",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16626",
  "rpc-client-utils": "static-1.4607",
  "sanitize-text": "static-1.8100",
  "styled-components": "static-2.88",
  "tanstack-table": "static-1.54",
  "ui-addon-draggable": "static-3.4726",
  "ui-addon-react-router-dom": "static-1.9502",
  "usage-tracker": "static-1.7296",
  "usage-tracker-anonymous": "static-1.5713",
  "usage-tracker-core": "static-1.7146",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3367",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3240",
  "quartz-webpack": "static-1.3187",
  "bend-plugin-quartz-routing": "static-1.41",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.81",
  "customer-data-objects": "static-1.7620",
  "frontend-preferences-client": "static-1.7884",
  "laboratory-lib": "static-3.7115",
  "onboarding-scopes": "static-1.6419",
  "ui-addon-opt": "static-4.8330",
  "HeadJS": "static-2.741",
  "hs-test-utils-bend-plugin": "static-1.3084",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.48",
  "ts-schema": "static-1.4042",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7680",
  "cssUtils": "static-1.780",
  "customer-data-ui-utilities": "static-1.9783",
  "HubStyle": "static-2.11726",
  "knowledge-content-types": "static-1.8479",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.638",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.486",
  "ui-addon-emoji-picker": "static-1.9845",
  "ui-addon-i18n": "static-1.11107",
  "ui-business-units-lib": "static-1.9005",
  "ui-shepherd-react": "static-3.10105",
  "video-components-external": "static-1.11109",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4281",
  "commerce-tours-lib": "static-1.6008",
  "customer-data-properties": "static-1.51377",
  "getting-started-shared-tasks": "static-1.18359",
  "growth-onboarding-reliability": "static-1.5038",
  "onboarding-tours": "static-1.16508",
  "reference-resolvers-lite": "static-1.8052",
  "sales-checkout-service-client": "static-1.3596",
  "ui-addon-iframeable": "static-1.9012",
  "user-context": "static-1.5058",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.827",
  "hubspotter-http": "static-1.4616",
  "icons": "static-2.644",
  "mobile-manifest-mixins": "static-1.515",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.638",
  "quartz-head": "static-1.628",
  "quartz-test": "static-1.638",
  "quartz-tracking": "static-1.342",
  "ui-fonts": "static-1.680",
  "usage-tracker-container": "static-1.7286",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9386",
  "data-token-picker": "static-1.16323",
  "FileManagerLib": "static-1.39126",
  "property-translator": "static-1.5358",
  "atom": "static-1.5029",
  "merchandise-lib": "static-1.262",
  "purchase-motions-components": "static-1.5800",
  "salesImages": "static-1.524",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5327",
  "react-select-plus": "static-1.104",
  "react-virtualized": "static-2.98",
  "ui-images": "static-2.1141",
  "bend-plugin-foundations-components": "static-1.4113",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.11",
  "trellis-assets": "static-1.1707",
  "bend-plugin-foundations-theming": "static-1.2856",
  "foundations-theming-base": "static-1.3358",
  "stylex": "static-1.32",
  "interframe": "static-3.4718",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5710",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "web-vitals": "static-1.4",
  "bend-plugin-chirp-manifest": "static-1.17",
  "chirp-fetch": "static-1.1842",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4429",
  "react-flip-move": "static-1.69",
  "bender-build-tools": "static-1.3123",
  "inbound-db-properties-service-client": "static-1.3805",
  "superstore": "static-1.4723",
  "feedback-loader": "static-1.29213",
  "ai-components-ui-library": "static-1.8812",
  "ui-addon-video-player": "static-1.8655",
  "ui-coaching-tips": "static-1.28409",
  "sassPrefix": "static-1.155",
  "react-dnd-compat": "static-1.4577",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2455",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8127",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4605",
  "content-media-composition-data-lib": "static-1.12088",
  "content-media-compositions": "static-2.16095",
  "idb-keyval": "static-1.43",
  "immer": "static-1.33",
  "immerable": "static-1.4110",
  "magpie-lib": "static-1.5532",
  "magpie-types": "static-1.4992",
  "media-bridge-lib": "static-1.18845",
  "video-data-lib": "static-1.34767",
  "commerce-products-lib": "static-1.9350",
  "crm-message-bus": "static-1.42855",
  "growth-data-modal": "static-1.5353",
  "hubspot-apollo-client": "static-1.4833",
  "onboarding-tours-client": "static-1.4722",
  "calling-global-api": "static-1.64342",
  "calling-internal-common": "static-1.31258",
  "calling-lifecycle-internal": "static-1.65724",
  "calling-lifecycle-messages": "static-1.58018",
  "conditional-properties-service-client": "static-1.3761",
  "crm-links": "static-1.6240",
  "customer-data-objects-ui-components": "static-1.12982",
  "customer-data-properties-shared-msw-handlers": "static-1.9181",
  "customer-data-property-utils": "static-1.8040",
  "external-options-client-types": "static-1.4123",
  "file-manager-components": "static-1.23486",
  "framework-data-schema-resolvers": "static-1.6835",
  "google-libphonenumber": "static-1.37",
  "hs-resources": "static-1.105",
  "inbound-db-meta-service-client": "static-1.3555",
  "inbounddb-objects-service-types": "static-1.4188",
  "meetings-icalendar-utils-lib": "static-1.588",
  "multi-currency-client-types": "static-1.3656",
  "object-builder-ui-client": "static-1.48570",
  "pipeline-validation-client-types": "static-1.3930",
  "property-value-citations": "static-1.1991",
  "pulse": "static-1.518",
  "smart-property-lib": "static-1.6688",
  "tiered-pricing": "static-1.1113",
  "ui-addon-form-validation": "static-1.10945",
  "growth-onboarding-confetti": "static-1.3024",
  "growth-onboarding-next-action-utils": "static-1.1771",
  "navigation-components": "static-1.17871",
  "onboarding-tours-utils": "static-1.574",
  "ui-shepherd-tracker": "static-1.7486",
  "ui-universal-auth": "static-1.8920",
  "batch-promise": "static-1.1507",
  "navigation-messaging": "static-1.7198",
  "getting-started-shared-tasks-store": "static-1.17477",
  "hubspotter-http-shared-msw-handlers": "static-1.9852",
  "usage-tracker-session-replay": "static-1.4982",
  "audio-components": "static-1.5845",
  "FileManagerCore": "static-1.38985",
  "FileManagerImages": "static-1.36637",
  "video-components": "static-1.13112",
  "foundations-components-legacy": "static-1.869",
  "purchase-motions-api": "static-1.5803",
  "self-service-api": "static-1.10202",
  "signup-constants": "static-1.18756",
  "signup-ui-url-generator": "static-2.7997",
  "trials-service-types": "static-1.3860",
  "usage-tracker-public": "static-1.7107",
  "chatspot-core": "static-1.21055",
  "ContentUtils": "static-1.68221",
  "copilot-toolkit": "static-1.10990",
  "growth-onboarding-feedback-components": "static-1.6540",
  "reactive-lib": "static-1.678",
  "simple-logging-lib": "static-1.3006",
  "commerce-permissions": "static-1.722",
  "customer-data-tracking": "static-1.6842",
  "products-iframe-lib": "static-1.7787",
  "products-ui-components-shared-msw-handlers": "static-1.10236",
  "onboarding-data-sync-lib": "static-1.1884",
  "hubspot-apollo-cache": "static-1.292",
  "calling-error-reporting": "static-1.31264",
  "shared-worker-versioning": "static-1.10994",
  "calling-usage-tracker": "static-1.6499",
  "voice-sms-access-library": "static-1.790",
  "conversations-skeleton-state": "static-1.7205",
  "location-customization-utils-lib": "static-1.9100",
  "crm-pipelines-api-client-types": "static-1.4107",
  "framework-builder-read-service-client": "static-1.3974",
  "framework-data-schema-quick-fetch": "static-1.6740",
  "persist-promise": "static-1.3664",
  "bend-plugin-pulse": "static-1.21",
  "directed-graph": "static-1.892",
  "event-emitter": "static-1.905",
  "fast-json-patch": "static-1.62",
  "data-agent-kit": "static-1.119",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9937",
  "fsm": "static-1.3689",
  "policy-lib": "static-1.6729",
  "react-tinymce": "static-1.55103",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10000",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54229",
  "tinymce-plugins": "static-1.57343",
  "tinymce-themes": "static-1.56199",
  "growth-onboarding-next-action-components": "static-1.1799",
  "user-context-client": "static-1.4567",
  "nest": "static-1.184",
  "unified-auth-core-lib": "static-1.715",
  "amplitude-session-replay-browser": "static-1.59",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4488",
  "video-embed": "static-1.35601",
  "content-icons-ui": "static-1.2214",
  "social-insights-client-types": "static-1.21953",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4768",
  "integrations-lib": "static-1.15962",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4221",
  "InboxConnectUtils": "static-4.14665",
  "calling-orchestration-schema": "static-1.35567",
  "crm-record-cards-service-types": "static-1.3574",
  "highcharts": "static-8.103",
  "trellis-story-utils": "static-1.4472",
  "storybook-react": "static-1.32",
  "hub-http-contrib": "static-1.2997",
  "tinymce-data": "static-1.40314",
  "ui-addon-sales-email": "static-1.5167",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12353",
  "layout-dnd-utils": "static-1.11328",
  "react-codemirror": "static-1.10580",
  "ui-brand-identity-lib": "static-1.15033",
  "NamespacedHubStyle": "static-2.9027",
  "outpost": "static-1.4144",
  "flux-actions": "static-1.331",
  "integrations-error-boundary-lib": "static-1.13377",
  "integrations-tracking-lib": "static-1.5555",
  "native-integrations-shared-strings": "static-1.7740",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10328",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.434",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68296",
  "layout-data-lib": "static-1.9653",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2969",
  "google-sheets-integration-lib": "static-1.93",
  "microsoft-drive-integration-lib": "static-1.207",
  "advanced-menus-core": "static-1.15054",
  "advanced-menus-lib": "static-1.12005",
  "ExportDialog": "static-6.10350",
  "ui-memberships-settings-lib": "static-1.33913",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15053",
  "simple-menus-lib": "static-1.16570"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2151",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.461",
  "data-fetching-client": "/data-fetching-client/static-1.9631",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.428",
  "growth-payments-core": "/growth-payments-core/static-1.25224",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5550",
  "hs-test-utils": "/hs-test-utils/static-1.7973",
  "hub-http": "/hub-http/static-1.6178",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9854",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18097",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11418",
  "I18n": "/I18n/static-7.1612",
  "immutable": "/immutable/static-2.77",
  "jasmine-runner": "/jasmine-runner/static-1.6426",
  "payment-link-components": "/payment-link-components/static-1.23396",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6963",
  "quartz-core": "/quartz-core/static-1.6182",
  "react": "/react/static-7.185",
  "react-colorpicker": "/react-colorpicker/static-2.10167",
  "react-dlb": "/react-dlb/static-1.78",
  "react-utils": "/react-utils/static-2.5308",
  "rich-text-lib": "/rich-text-lib/static-1.19749",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17922",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5556",
  "UIComponents": "/UIComponents/static-3.8365",
  "foundations-assets": "/foundations-assets/static-1.4813",
  "foundations-components": "/foundations-components/static-1.7844",
  "foundations-theming": "/foundations-theming/static-1.4373",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2089",
  "framer-motion": "/framer-motion/static-1.71",
  "metrics-js": "/metrics-js/static-1.9542",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "portals-platform-lib": "/portals-platform-lib/static-1.809",
  "quartz-config": "/quartz-config/static-1.741",
  "quartz-routing": "/quartz-routing/static-1.393",
  "quick-fetch": "/quick-fetch/static-1.3881",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16626",
  "rpc-client-utils": "/rpc-client-utils/static-1.4607",
  "sanitize-text": "/sanitize-text/static-1.8100",
  "styled-components": "/styled-components/static-2.88",
  "tanstack-table": "/tanstack-table/static-1.54",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4726",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9502",
  "usage-tracker": "/usage-tracker/static-1.7296",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5713",
  "usage-tracker-core": "/usage-tracker-core/static-1.7146",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3367",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3240",
  "quartz-webpack": "/quartz-webpack/static-1.3187",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.41",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.81",
  "customer-data-objects": "/customer-data-objects/static-1.7620",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7884",
  "laboratory-lib": "/laboratory-lib/static-3.7115",
  "onboarding-scopes": "/onboarding-scopes/static-1.6419",
  "ui-addon-opt": "/ui-addon-opt/static-4.8330",
  "HeadJS": "/HeadJS/static-2.741",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3084",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.48",
  "ts-schema": "/ts-schema/static-1.4042",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7680",
  "cssUtils": "/cssUtils/static-1.780",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9783",
  "HubStyle": "/HubStyle/static-2.11726",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.638",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9845",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11107",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9005",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10105",
  "video-components-external": "/video-components-external/static-1.11109",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4281",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6008",
  "customer-data-properties": "/customer-data-properties/static-1.51377",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18359",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5038",
  "onboarding-tours": "/onboarding-tours/static-1.16508",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8052",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3596",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9012",
  "user-context": "/user-context/static-1.5058",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.827",
  "hubspotter-http": "/hubspotter-http/static-1.4616",
  "icons": "/icons/static-2.644",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.515",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.638",
  "quartz-head": "/quartz-head/static-1.628",
  "quartz-test": "/quartz-test/static-1.638",
  "quartz-tracking": "/quartz-tracking/static-1.342",
  "ui-fonts": "/ui-fonts/static-1.680",
  "usage-tracker-container": "/usage-tracker-container/static-1.7286",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9386",
  "data-token-picker": "/data-token-picker/static-1.16323",
  "FileManagerLib": "/FileManagerLib/static-1.39126",
  "property-translator": "/property-translator/static-1.5358",
  "atom": "/atom/static-1.5029",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "purchase-motions-components": "/purchase-motions-components/static-1.5800",
  "salesImages": "/salesImages/static-1.524",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5327",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-virtualized": "/react-virtualized/static-2.98",
  "ui-images": "/ui-images/static-2.1141",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4113",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.11",
  "trellis-assets": "/trellis-assets/static-1.1707",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2856",
  "foundations-theming-base": "/foundations-theming-base/static-1.3358",
  "stylex": "/stylex/static-1.32",
  "interframe": "/interframe/static-3.4718",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5710",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "web-vitals": "/web-vitals/static-1.4",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.17",
  "chirp-fetch": "/chirp-fetch/static-1.1842",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4429",
  "react-flip-move": "/react-flip-move/static-1.69",
  "bender-build-tools": "/bender-build-tools/static-1.3123",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3805",
  "superstore": "/superstore/static-1.4723",
  "feedback-loader": "/feedback-loader/static-1.29213",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8812",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8655",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28409",
  "sassPrefix": "/sassPrefix/static-1.155",
  "react-dnd-compat": "/react-dnd-compat/static-1.4577",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2455",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8127",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4605",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12088",
  "content-media-compositions": "/content-media-compositions/static-2.16095",
  "idb-keyval": "/idb-keyval/static-1.43",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4110",
  "magpie-lib": "/magpie-lib/static-1.5532",
  "magpie-types": "/magpie-types/static-1.4992",
  "media-bridge-lib": "/media-bridge-lib/static-1.18845",
  "video-data-lib": "/video-data-lib/static-1.34767",
  "commerce-products-lib": "/commerce-products-lib/static-1.9350",
  "crm-message-bus": "/crm-message-bus/static-1.42855",
  "growth-data-modal": "/growth-data-modal/static-1.5353",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4833",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4722",
  "calling-global-api": "/calling-global-api/static-1.64342",
  "calling-internal-common": "/calling-internal-common/static-1.31258",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65724",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58018",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3761",
  "crm-links": "/crm-links/static-1.6240",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12982",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9181",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8040",
  "external-options-client-types": "/external-options-client-types/static-1.4123",
  "file-manager-components": "/file-manager-components/static-1.23486",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6835",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "hs-resources": "/hs-resources/static-1.105",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3555",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4188",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.588",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3656",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48570",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3930",
  "property-value-citations": "/property-value-citations/static-1.1991",
  "pulse": "/pulse/static-1.518",
  "smart-property-lib": "/smart-property-lib/static-1.6688",
  "tiered-pricing": "/tiered-pricing/static-1.1113",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10945",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3024",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1771",
  "navigation-components": "/navigation-components/static-1.17871",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.574",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7486",
  "ui-universal-auth": "/ui-universal-auth/static-1.8920",
  "batch-promise": "/batch-promise/static-1.1507",
  "navigation-messaging": "/navigation-messaging/static-1.7198",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17477",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9852",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4982",
  "audio-components": "/audio-components/static-1.5845",
  "FileManagerCore": "/FileManagerCore/static-1.38985",
  "FileManagerImages": "/FileManagerImages/static-1.36637",
  "video-components": "/video-components/static-1.13112",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.869",
  "purchase-motions-api": "/purchase-motions-api/static-1.5803",
  "self-service-api": "/self-service-api/static-1.10202",
  "signup-constants": "/signup-constants/static-1.18756",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7997",
  "trials-service-types": "/trials-service-types/static-1.3860",
  "usage-tracker-public": "/usage-tracker-public/static-1.7107",
  "chatspot-core": "/chatspot-core/static-1.21055",
  "ContentUtils": "/ContentUtils/static-1.68221",
  "copilot-toolkit": "/copilot-toolkit/static-1.10990",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6540",
  "reactive-lib": "/reactive-lib/static-1.678",
  "simple-logging-lib": "/simple-logging-lib/static-1.3006",
  "commerce-permissions": "/commerce-permissions/static-1.722",
  "customer-data-tracking": "/customer-data-tracking/static-1.6842",
  "products-iframe-lib": "/products-iframe-lib/static-1.7787",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10236",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1884",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.292",
  "calling-error-reporting": "/calling-error-reporting/static-1.31264",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10994",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6499",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.790",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7205",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9100",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4107",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3974",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6740",
  "persist-promise": "/persist-promise/static-1.3664",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.21",
  "directed-graph": "/directed-graph/static-1.892",
  "event-emitter": "/event-emitter/static-1.905",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "data-agent-kit": "/data-agent-kit/static-1.119",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9937",
  "fsm": "/fsm/static-1.3689",
  "policy-lib": "/policy-lib/static-1.6729",
  "react-tinymce": "/react-tinymce/static-1.55103",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10000",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54229",
  "tinymce-plugins": "/tinymce-plugins/static-1.57343",
  "tinymce-themes": "/tinymce-themes/static-1.56199",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1799",
  "user-context-client": "/user-context-client/static-1.4567",
  "nest": "/nest/static-1.184",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.715",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4488",
  "video-embed": "/video-embed/static-1.35601",
  "content-icons-ui": "/content-icons-ui/static-1.2214",
  "social-insights-client-types": "/social-insights-client-types/static-1.21953",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4768",
  "integrations-lib": "/integrations-lib/static-1.15962",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4221",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14665",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35567",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3574",
  "highcharts": "/highcharts/static-8.103",
  "trellis-story-utils": "/trellis-story-utils/static-1.4472",
  "storybook-react": "/storybook-react/static-1.32",
  "hub-http-contrib": "/hub-http-contrib/static-1.2997",
  "tinymce-data": "/tinymce-data/static-1.40314",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5167",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12353",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11328",
  "react-codemirror": "/react-codemirror/static-1.10580",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15033",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9027",
  "outpost": "/outpost/static-1.4144",
  "flux-actions": "/flux-actions/static-1.331",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13377",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5555",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7740",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10328",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.434",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68296",
  "layout-data-lib": "/layout-data-lib/static-1.9653",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2969",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.93",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.207",
  "advanced-menus-core": "/advanced-menus-core/static-1.15054",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12005",
  "ExportDialog": "/ExportDialog/static-6.10350",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33913",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15053",
  "simple-menus-lib": "/simple-menus-lib/static-1.16570"
}
};
